module.exports = __webpack_public_path__ + "img/PL09221.cec5d1f5.png";